module.exports = __webpack_public_path__ + "static/pros-and-cons-of-debt-consolidation-loans-f30c122e3cf10b126ca9466d6b44a05c.png";